import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "range", "value", "onChange", "onFocus", "onBlur", "minDate", "disabled", "invert", "maxDate", "disableDates", "rightSide", "onClear"],
  _excluded2 = ["className", "range", "value", "onChange", "onFocus", "onBlur", "invert", "minDate", "maxDate", "rightSide", "disabled", "disableDates", "onClear"];
import React, { forwardRef } from 'react';
import { format } from 'date-fns-new';
import { IconCalendarFilled } from '@carnica/graphics';
import { DateRangeInput, DateInput as SingleDateInput } from "../../../AdvancedInputs";
import { dateFormat, useRangeInput, useSingleInput } from "../../hooks/usePickerInput";
import { getIconColor, isNotRangeParams, isRangeParams } from "./utils";
var SingleInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    range = props.range,
    value = props.value,
    onChange = props.onChange,
    _onFocus = props.onFocus,
    _onBlur = props.onBlur,
    minDate = props.minDate,
    disabled = props.disabled,
    invert = props.invert,
    maxDate = props.maxDate,
    disableDates = props.disableDates,
    rightSide = props.rightSide,
    _onClear = props.onClear,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useSingleInput = useSingleInput({
      range: range,
      value: value,
      disableDates: disableDates,
      onChange: onChange,
      minDate: minDate,
      maxDate: maxDate
    }),
    maskOptions = _useSingleInput.maskOptions,
    handleChange = _useSingleInput.onChange;
  return /*#__PURE__*/React.createElement(SingleDateInput, _extends({}, otherProps, {
    "aria-haspopup": "dialog",
    "aria-roledescription": "\u041F\u043E\u043B\u0435 \u0432\u0432\u043E\u0434\u0430 \u0434\u0430\u0442\u044B",
    disabled: disabled,
    inputMode: "tel",
    invert: invert,
    maskOptions: maskOptions,
    onBlur: function onBlur(_, e) {
      return _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(value || null, e);
    },
    onChange: handleChange,
    onClear: function onClear(_, e) {
      return _onClear === null || _onClear === void 0 ? void 0 : _onClear(null, e);
    },
    onFocus: function onFocus(_, e) {
      return _onFocus === null || _onFocus === void 0 ? void 0 : _onFocus(value || null, e);
    },
    ref: ref,
    rightSide: rightSide || /*#__PURE__*/React.createElement(IconCalendarFilled, {
      "aria-haspopup": "dialog",
      color: getIconColor(disabled, invert),
      size: "m"
    }),
    role: "textbox",
    type: "text",
    unmask: false,
    value: value ? format(value, dateFormat) : '',
    "data-t-id": "Input-DateInput"
  }));
});
var RangeInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    range = props.range,
    value = props.value,
    onChange = props.onChange,
    _onFocus2 = props.onFocus,
    _onBlur2 = props.onBlur,
    invert = props.invert,
    minDate = props.minDate,
    maxDate = props.maxDate,
    rightSide = props.rightSide,
    disabled = props.disabled,
    disableDates = props.disableDates,
    _onClear2 = props.onClear,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var _useRangeInput = useRangeInput({
      range: range,
      value: value,
      disableDates: disableDates,
      onChange: onChange,
      minDate: minDate,
      maxDate: maxDate
    }),
    maskOptions = _useRangeInput.maskOptions,
    handleChange = _useRangeInput.onChange,
    stringValue = _useRangeInput.stringValue;
  return /*#__PURE__*/React.createElement(DateRangeInput, _extends({}, otherProps, {
    disabled: disabled,
    invert: invert,
    maskOptions: maskOptions,
    onBlur: function onBlur(_, e) {
      return _onBlur2 === null || _onBlur2 === void 0 ? void 0 : _onBlur2(value || [null, null], e);
    },
    onChange: handleChange,
    onClear: function onClear(_, e) {
      return _onClear2 === null || _onClear2 === void 0 ? void 0 : _onClear2([null, null], e);
    },
    onFocus: function onFocus(_, e) {
      return _onFocus2 === null || _onFocus2 === void 0 ? void 0 : _onFocus2(value || [null, null], e);
    },
    ref: ref,
    rightSide: rightSide || /*#__PURE__*/React.createElement(IconCalendarFilled, {
      color: getIconColor(disabled, invert),
      size: "m"
    }),
    type: "text",
    unmask: false,
    value: stringValue
  }));
});
export var DateInput = /*#__PURE__*/forwardRef(function (props, ref) {
  if (isRangeParams(props)) {
    return /*#__PURE__*/React.createElement(RangeInput, _extends({}, props, {
      ref: ref
    }));
  }
  if (isNotRangeParams(props)) {
    return /*#__PURE__*/React.createElement(SingleInput, _extends({}, props, {
      ref: ref
    }));
  }
  return null;
});